'use client'
import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import Icon from './Icon'

export interface FaqItem {
  question: string
  answer: string
}

interface FaqProps {
  items: FaqItem[]
  className?: string
}

export default function Faq({ items, className }: FaqProps) {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <div className={className}>
      {items.map((item, i) => {
        const isOpen = open === i
        return (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.4, delay: i * 0.04 }}
            className={`rounded-xl border bg-white/[0.02] transition-colors duration-300 ${
              isOpen ? 'border-[rgb(var(--brand-rgb)/0.3)]' : 'border-white/[0.06]'
            }`}
          >
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-start cursor-pointer"
            >
              <span className="text-[15px] sm:text-base font-medium text-white leading-snug">{item.question}</span>
              <span
                className={`shrink-0 w-7 h-7 rounded-full border flex items-center justify-center transition-all duration-300 ${
                  isOpen
                    ? 'rotate-180 border-[rgb(var(--brand-rgb)/0.4)] text-[var(--brand-400)]'
                    : 'border-white/[0.1] text-[#64748b]'
                }`}
              >
                <Icon name="chevron-down" className="w-4 h-4" />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.25, ease: 'easeInOut' }}
                  className="overflow-hidden"
                >
                  <p className="px-5 sm:px-6 pb-6 text-sm text-[#94a3b8] leading-relaxed">{item.answer}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        )
      })}
    </div>
  )
}